// import React from "react";

// const features = [
//   "Up to 4 Devices per Account",
//   "Watch Live TV & Sports",
//   "No Hidden Fees",
//   "Monthly Subscription, No Contracts",
//   "Easy APK Installation",
// ];

// const PremiumFeatures = () => (
//   <section className="features">
//     <div className="scrolling-features">
//       {features.map((f, i) => (
//         <span key={i} className="feature-item">{f}</span>
//       ))}
//     </div>
//   </section>
// );

// export default PremiumFeatures;


import React from "react";
import espnlogo from '../assets/espnlogo.png'
import ppvlogo from '../assets/ppvlogo.png'
import hbologo from '../assets/hbologo.png'
import cinemaxlogo from '../assets/cinemaxlogo.png'
import starzlogo from '../assets/starzlogo.png'
import betlogo from '../assets/betlogo.png'
import disneylogo from '../assets/disneylogo.jpg'
import mgmlogo from '../assets/mgmlogo.png'
import showtimelogo from '../assets/showtimelogo.png'
import vh1logo from '../assets/vh1logo.png'
import nfllogo from '../assets/nfllogo.png'
import nbalogo from '../assets/nbalogo.png'
import nhllogo from '../assets/nhllogo.png'
import mlblogo from '../assets/mlblogo.png'
import ncaalogo from '../assets/ncaalogo.png'



const channelLogos = [
  { name: "ESPN", url: espnlogo },
  { name: "HBO", url: hbologo },
  { name: "PPV", url: ppvlogo },
  { name: "Cinemax", url: cinemaxlogo },
  { name: "Starz", url: starzlogo },
  { name: "Bet", url: betlogo },
  { name: "Disney", url: disneylogo },
  { name: "MGM", url: mgmlogo },
  { name: "Showtime", url: showtimelogo },
  { name: "VH1", url: vh1logo },
  { name: "NFL", url: nfllogo },
  { name: "NBA", url: nbalogo },
  { name: "NHL", url: nhllogo },
  { name: "MLB", url: mlblogo },
  { name: "NCAA", url: ncaalogo },
];


const PremiumFeatures = () => (
  <section style={styles.section}>
    <style>{styles.keyframes}</style>
    <h2 style={styles.heading}>All your favorite Channels - Movies - & TV Series in one place — at a low monthly cost.</h2>
    <div className="scrolling-logos" style={styles.scrollContainer}>
      <div style={styles.scrollContent}>
        {[...channelLogos, ...channelLogos].map((channel, i) => (
          <img
            key={i}
            src={channel.url}
            alt={channel.name}
            style={styles.logo}
          />
        ))}
      </div>
    </div>
  </section>
);

export default PremiumFeatures;


const styles = {
    section: {
      textAlign: "center",
      padding: "2rem",
      backgroundColor: "#0d0d0d",
      overflow: "hidden",
    },
    heading: {
      color: "#ffffff",
      marginBottom: "1.5rem", 
      fontSize: "1.5rem",
    },
    scrollContainer: {
      overflow: "hidden",
      width: "100%",
    },
    scrollContent: {
      display: "flex",
      gap: "3rem",
      animation: "scrollLeft 90s linear infinite",
      width: "max-content",
    },
    logo: {
      height: "100px",
      width: "200px",
      objectFit: "contain",
    //   filter: "brightness(1) invert(0)",
      flexShrink: 0,
    },
    keyframes: `
      @keyframes scrollLeft {
        0% { transform: translateX(0); }
        100% { transform: translateX(-50%); }
      }
  
      .scrolling-logos::-webkit-scrollbar {
        display: none;
      }
    `,
  };
  